export default __webpack_public_path__ + "static/media/discount175.452613aa.jpg";